



































import { Org, Product } from '@/api';
import { OrdwayService } from '@/services/ordway-service';
import OrgSuggest from '@/components/form pickers/orgSuggest.vue';
import { Component, Vue, Prop } from 'vue-property-decorator';
import SaveCancelButtons from '@/components/elements/buttons/save-cancel-buttons.vue';
import { ApiUtils } from '@/common/ApiUtils';
import Toast from '@/components/display/toast.vue';

@Component({
	components: {
		SaveCancelButtons,
		OrgSuggest,
	},
})
export default class ChangeProductOrgModal extends Vue {
	@Prop()
	public product!: Product & { org: Org };

	@Prop()
	public org!: Org;

	public orgId: number | null = this.org?.id ?? null;

	public loading: boolean = false;

	public async changeOrg() {
		this.loading = true;
		try {
			await OrdwayService.changeProductOrg(this.product.id!, this.product.org.id!);
			this.$emit('orgChanged');
		} catch (ex) {
			const error = ApiUtils.handleApiError(ex, 'Failed to change org');
			console.log(error.errorMessage);
			new Toast().makeToast(error.errorMessage, 'Error Changing Org', 'danger');
		}
		this.loading = false;
	}

	public async resetProductOrg() {
		this.$emit('resetProductOrg');
	}

	public closeModal(): void {
		this.$bvModal.hide('product-org-change-modal');
	}
}
